export class RedemptionsListFilters {
  status?: number;
  date?: number | (Date | null)[];

  static toDto(filters: RedemptionsListFilters) {
    const redemptionsListFilters = { ...filters };
    const redemptionsListFiltersDto = {} as RedemptionsSlistFiltersDto;

    redemptionsListFiltersDto.rewardProgramCode = 'Commissions';
    if (!redemptionsListFilters.status) setEmptyStatus();
    else redemptionsListFiltersDto.status = mapStatusToDto(redemptionsListFilters.status);

    if (!redemptionsListFilters.date) setDefaultdate();

    if (typeof redemptionsListFilters.date === 'number') {
      redemptionsListFilters.date = convertRangeNumToDateRange(redemptionsListFilters.date);
    }

    if (
      Array.isArray(redemptionsListFilters.date) &&
      redemptionsListFilters.date.every((d) => d === null)
    )
      setDefaultdate();
    if (Array.isArray(redemptionsListFilters.date) && !redemptionsListFilters.date[0])
      setDefaultdate();
    if (Array.isArray(redemptionsListFilters.date) && redemptionsListFilters.date[0]) {
      if (!redemptionsListFilters.date.at(1)) {
        redemptionsListFiltersDto.StartDate =
          redemptionsListFilters.date.at(0)?.getTime().toString() ?? '';
        redemptionsListFiltersDto.EndDate =
          redemptionsListFilters.date.at(0)?.getTime().toString() ?? '';
      } else {
        redemptionsListFiltersDto.StartDate =
          redemptionsListFilters.date.at(0)?.getTime().toString() ?? '';
        redemptionsListFiltersDto.EndDate =
          redemptionsListFilters.date.at(1)?.getTime().toString() ?? '';
      }
    }

    function mapStatusToDto(status: number | string) {
      switch (status) {
        case 1:
          return 'PENDING';
        case 'Solicitado':
          return 'PENDING';
        case 2:
          return 'APPROVED';
        case 'Aprovado':
          return 'APPROVED';
        case 3:
          return 'REJECTED';
        case 'Recusado':
          return 'REJECTED';
        case 4:
          return 'DELIVERED';
        case 'Pago':
          return 'DELIVERED';
        default:
          return undefined;
      }
    }

    function setEmptyStatus() {
      redemptionsListFiltersDto.status = undefined;
    }
    function setDefaultdate() {
      redemptionsListFilters.date = convertRangeNumToDateRange();
    }
    function convertRangeNumToDateRange(rangeNum: number = 15) {
      const end = new Date(Date.now());
      const start = new Date(new Date().setDate(end.getDate() - rangeNum));
      return [start, end] as Date[];
    }
    return redemptionsListFiltersDto;
  }
}

export type RedemptionsSlistFiltersDto = {
  status?: 'APPROVED' | 'PENDING' | 'REJECTED' | 'DELIVERED';
  StartDate?: string;
  EndDate?: string;
  rewardProgramCode: string;
};
